import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import announcementRepository from '../../repositories/announcement/announcementRepository';
import mediaRepository from '../../repositories/general/mediaRepository';

const dataAnnouncement = {
  content: null,
  image: null,
  image_collect: [],
  is_highlight: 0,
};

export const useAnnouncementStore = defineStore('announcementStore', {
  state: () => ({
    componentKey: 0,
    isSuccess: false,
    hasErrorSingle: null,
    // list page
    perpage: 20,
    search: null,
    page: 1,
    listData: [],
    pagination: {},
    isLoadingTable: false,
    // form page
    formData: structuredClone(dataAnnouncement),
    hasFormError: structuredClone(dataAnnouncement),
    isLoadingForm: false,
  }),
  actions: {
    async getData() {
      try {
        this.isLoadingTable = true;
        this.hasErrorSingle = null;
        this.isSuccess = false;

        const params = {
          search: this.search,
          page: this.page,
          perpage: this.perpage,
        };
        const dataAnnouncement = await announcementRepository.getData(params);
        if (dataAnnouncement.data.status === 200) {
          this.listData = dataAnnouncement.data.data.announcement.list;
          this.pagination = dataAnnouncement.data.data.announcement.pagination;
          this.isLoadingTable = false;
          this.componentKey++;
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isLoadingTable = false;
        this.isSuccess = false;
      }
    },
    async searchData() {
      this.page = 1;
      await this.getData();
    },
    async getDataByPaging() {
      await this.getData();
    },
    async saveData() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const saveAnnouncement = await announcementRepository.saveData(params);
        if (saveAnnouncement.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async getDataDetail(id) {
      this.isSuccess = false;

      const params = {
        ann_id: id,
      };
      const dataDetailAnnouncement = await announcementRepository.getDataDetail(params);

      if (dataDetailAnnouncement.data.status === 200) {
        this.isSuccess = true;
        const data = dataDetailAnnouncement.data.data;

        this.formData.content = data.desc;
        this.formData.is_highlight = data.is_highlight === 1 ? true : false;
        this.formData.image = data.image.file_id;
        this.formData.image_collect = data.image;
      }
    },
    async updateData(id) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const params = {
          ann_id: id,
          ...this.formData,
        };
        const updateAnnouncemnt = await announcementRepository.updateData(params);
        if (updateAnnouncemnt.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async deleteData(id) {
      try {
        this.isSuccess = false;

        const params = {
          ann_id: id,
        };
        const deleteAnnouncement = await announcementRepository.deleteData(params);
        if (deleteAnnouncement.data.status === 200) {
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
      }
    },
    async uploadFile(file, type) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const uploadFile = await mediaRepository.uploadFile(file);
        if (uploadFile.data.status === 200) {
          this.isSuccess = true;
          if (type === 'MAIN_IMAGE') {
            this.formData.image = uploadFile.data.data.file_id;
            this.formData.image_collect = uploadFile.data.data;
          }
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
        this.setFormError(error.response.data.error);
      } finally {
        this.isLoadingForm = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataAnnouncement);
      }
      this.hasFormError = structuredClone(dataAnnouncement);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useAnnouncementStore, import.meta.webpackHot));
}
